document.addEventListener("DOMContentLoaded", () => {

class BannerSlide{

constructor(slider){

this.slider=slider;

this.wrapper=slider.querySelector(".banner-slide-2__wrapper");

this.slides=slider.querySelectorAll(".banner-slide-2__slide");

this.prevBtn=slider.querySelector(".banner-slide-2__prev");

this.nextBtn=slider.querySelector(".banner-slide-2__next");

this.dotsContainer=slider.querySelector(".banner-slide-2__dots");

this.current=0;

this.interval=null;

this.settings={

showArrows:slider.dataset.showArrows==="true",

showDots:slider.dataset.showDots==="true",

autoplay:slider.dataset.autoplay==="true",

speed:Number(slider.dataset.speed)*1000,

loop:slider.dataset.loop==="true",

desktopHeight:Number(slider.dataset.desktopHeight),

mobileHeight:Number(slider.dataset.mobileHeight),

desktopAuto:slider.dataset.desktopAutoHeight==="true",

mobileAuto:slider.dataset.mobileAutoHeight==="true",

desktopFit:slider.dataset.desktopFit,

mobileFit:slider.dataset.mobileFit

};

this.init();

}

init(){

    this.createDots();

    this.applySettings();

    this.bindEvents();

    this.update();

    if(this.settings.autoplay){

        this.startAutoplay();

    }

}

createDots(){

this.dotsContainer.innerHTML="";

this.slides.forEach((slide,index)=>{

const dot=document.createElement("button");

dot.className="banner-slide-2__dot";

dot.addEventListener("click",()=>{

this.goTo(index);

});

this.dotsContainer.appendChild(dot);

});

this.dots=this.dotsContainer.querySelectorAll(".banner-slide-2__dot");

}

applySettings(){

if(!this.settings.showArrows){

this.prevBtn.style.display="none";

this.nextBtn.style.display="none";

}

if(!this.settings.showDots){

this.dotsContainer.style.display="none";

}

}

bindEvents(){

this.nextBtn.addEventListener("click",()=>{

this.next();

});

this.prevBtn.addEventListener("click",()=>{

this.prev();

});

this.slider.addEventListener("mouseenter",()=>{

this.stopAutoplay();

});

this.slider.addEventListener("mouseleave",()=>{

if(this.settings.autoplay){

this.startAutoplay();

}

});

}

update(){

this.wrapper.style.transform=`translateX(-${this.current*100}%)`;

this.dots.forEach(dot=>dot.classList.remove("active"));

if(this.dots[this.current]){

this.dots[this.current].classList.add("active");

}

}

goTo(index){

this.current=index;

this.update();

}

next(){

this.current++;

if(this.current>=this.slides.length){

if(this.settings.loop){

this.current=0;

}else{

this.current=this.slides.length-1;

this.stopAutoplay();

}

}

this.update();

}

        prev(){

            this.current--;

            if(this.current<0){

                if(this.settings.loop){

                    this.current=this.slides.length-1;

                }else{

                    this.current=0;

                }

            }

            this.update();

        }

        startAutoplay(){

            this.stopAutoplay();

            this.interval=setInterval(()=>{

                this.next();

            },this.settings.speed);

        }

        stopAutoplay(){

            if(this.interval){

                clearInterval(this.interval);

                this.interval=null;

            }

        }

    }

    document.querySelectorAll(".banner-slide-2").forEach(slider=>{

        new BannerSlide(slider);

    });

});